import React from 'react';
import './Space.css';

const Space: React.FC = () => {
  return (
    <div className="space">
      {/* Hero Section */}
      <section className="space-hero">
        <div className="container">
          <div className="hero-content">
            <h1 className="page-title">VISIT OUR SPACE</h1>
            <div className="hero-description">
              <p>Find us near Aristotelous Square, on the 5th floor of a hidden arcade (στοά), right across from Agora Modiano, in the heart of Thessaloniki.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Brand Section */}
      <section className="brand-section">
        <div className="container">
          <div className="brand-content">
            <div className="brand-subtitle">
              <span className="star">✮</span>
              <span className="brand-name">Eco Fashion</span>
              <span className="star">✮</span>
            </div>
            <p className="brand-description">
              is not your typical vintage shop, it's part showroom, part atelier, and fully nostalgic. Where DIY punk meets 90s cool and early 2000s energy, with mirrors, posters, curated playlists, and racks of carefully selected pieces. The vibe is cozy, edgy, and unexpected, like discovering a backstage dressing room from another era <span className="symbol">⋆⭒˚.⋆</span>
            </p>
          </div>
        </div>
      </section>

      {/* Space Gallery */}
      <section className="space-gallery">
        <div className="container">
          <div className="gallery-grid">
            <div className="gallery-item main-image">
              <img src="https://images.unsplash.com/photo-1441986300917-64674bd600d8?w=800&h=600&fit=crop" alt="Main Store View" />
              <div className="image-overlay">
                <span className="image-label">Main Store View</span>
              </div>
            </div>
            <div className="gallery-item">
              <img src="/images/our-store.jpg" alt="Atelier Space" />
              <div className="image-overlay">
                <span className="image-label">In-House Atelier</span>
              </div>
            </div>
            <div className="gallery-item">
              <img src="/images/our-store2.jpg" alt="Curated Collections" />
              <div className="image-overlay">
                <span className="image-label">Curated Collections</span>
              </div>
            </div>
            <div className="gallery-item">
              <img src="https://images.unsplash.com/photo-1556905055-8f358a7a47b2?w=400&h=300&fit=crop" alt="Vintage Details" />
              <div className="image-overlay">
                <span className="image-label">Vintage Details</span>
              </div>
            </div>
            <div className="gallery-item">
              <img src="https://images.unsplash.com/photo-1567401893414-76b7b1e5a7a5?w=400&h=300&fit=crop" alt="Style Corner" />
              <div className="image-overlay">
                <span className="image-label">Style Corner</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* What We Do */}
      <section className="what-we-do">
        <div className="container">
          <div className="content-box">
            <p className="what-description">
              We curate authentic vintage, deadstock, and designer pieces, and create reworked collections right here in our in-house atelier, visible just behind the glass.
            </p>
          </div>
        </div>
      </section>

      {/* Directions Section */}
      <section className="directions-section">
        <h2 className="directions-title">
          <span className="compass-icon">🧭</span>
          HOW TO GET THERE
        </h2>
        <div className="title-decoration">
          <div className="deco-line"></div>
          <div className="deco-dot"></div>
          <div className="deco-line"></div>
        </div>
        
        <div className="container">
          <div className="directions-layout">
            <div className="info-group">
              <div className="info-section">
                <h3><span className="icon">📍</span> Address</h3>
                <p>Vasileos Irakleiou 28, 5th Floor</p>
                <p>Thessaloniki City Center</p>
              </div>
              
              <div className="info-section">
                <h3><span className="icon">🕒</span> Opening Hours</h3>
                <p><strong>Tuesday, Thursday, Friday & Saturday</strong></p>
                <p>12:00 – 21:00</p>
                <p className="private-note">📲 DM us on Instagram <strong>@eco.fashion.living</strong> to book a private visit on off days</p>
              </div>
            </div>
            
            <div className="info-group">
              <div className="info-section">
                <h3><span className="icon">🚇</span> By Metro</h3>
                <p>Exit at <strong>Venizelou Station</strong>, turn onto Vasileos Irakleiou (you're here in under a minute)</p>
              </div>
              
              <div className="info-section">
                <h3><span className="icon">🚌</span> By Bus</h3>
                <p>Get off at <strong>Aristotelous</strong> or <strong>Agora Modiano</strong> stops (we're a short walk away)</p>
              </div>
              
            </div>
            
            <div className="info-group">
              <div className="info-section finding-note">
                <p>Look for the arcade entrance across from Agora Modiano and head up to the 5th floor by taking the elevator or the stairs!!</p>
                <p className="confidence-text">You'll know when you've found us!</p>
                <p>But if you need help, DM us on Instagram (<strong>@eco.fashion.living</strong>) or email us at <strong>eco.fashion.living@gmail.com</strong>. We've got you.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Video Guide Section */}
      <section className="video-section">
        <div className="container">
          <div className="video-content">
            <div className="video-header">
              <span className="video-icon">🎥</span>
              <h3>Need visuals? Watch this quick video guide showing exactly how to find our space!</h3>
            </div>
            <div className="video-placeholder">
              <div className="video-thumb">
                <img src="https://images.unsplash.com/photo-1536440136628-849c177e76a1?w=800&h=450&fit=crop" alt="Video Guide Thumbnail" />
                <div className="play-button">
                  <span className="play-icon">▶</span>
                </div>
              </div>
              <p className="video-caption">Step-by-step guide to finding our hidden arcade space</p>
            </div>
          </div>
        </div>
      </section>

      {/* Google Maps */}
      <section className="map-section">
        <div className="container">
          <div className="map-placeholder">
            <div className="map-content">
              <h4>Find Us Here</h4>
              <p>Vasileos Irakleiou 28, 5th Floor, Thessaloniki</p>
              <div className="google-map">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3048.4147494!2d22.944!3d40.6361!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zNDDCsDM4JzEwLjAiTiAyMsKwNTYnMzguNCJF!5e0!3m2!1sen!2sgr!4v1234567890!5m2!1sen!2sgr"
                  width="100%"
                  height="400"
                  style={{border: 0}}
                  allowFullScreen={true}
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="Eco Fashion Location"
                ></iframe>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Space;